import { CustomValidatorArgs } from '../types/CSVTypes';
import { HeaderColumnKeyEnum } from '../types/columnHeader';
import { coordinateIsNullOrUndefined, getCoordinateCell } from './latLngValidator';

export const addressValidator = ({ type, row, locationHeaders }: CustomValidatorArgs) => {

  const lat = getCoordinateCell(HeaderColumnKeyEnum.LATITUDE, row, locationHeaders);
  const long = getCoordinateCell(HeaderColumnKeyEnum.LONGITUDE, row, locationHeaders);

  if (type === 'null' && coordinateIsNullOrUndefined(lat) && coordinateIsNullOrUndefined(long)) {
    return 'missingAddress';
  }
  return null;
};

